import type { RouterConfig } from '@nuxt/schema'
import { useNuxtApp } from '#app'

export default <RouterConfig>{
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }

    const toSegments = to.path.split('/').filter(Boolean)
    const fromSegments = from.path.split('/').filter(Boolean)

    // Переход внутри вложенной секции того же ресурса (например, /schools/123/... → /schools/123/...)
    // — не сбрасываем прокрутку.
    if (
      toSegments.length >= 2 &&
      fromSegments.length >= 2 &&
      toSegments[0] === fromSegments[0] &&
      toSegments[1] === fromSegments[1]
    ) {
      return
    }

    // На сервере scrollBehavior не вызывается, оставляем заглушку для типов.
    if (!import.meta.client) {
      return { top: 0 }
    }

    // Дожидаемся полной загрузки новой страницы (resolve Suspense),
    // чтобы не было скачка вверх до подгрузки контента.
    return new Promise((resolve) => {
      useNuxtApp().hooks.hookOnce('page:loading:end', () => {
        requestAnimationFrame(() => resolve({ top: 0 }))
      })
    })
  },
}
